import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionRoomRequiredPrepMillisecond } from "./required-prep-milli-second";

import type { StandardRoomCategoriesAndManagerStore } from "../../store/categories";

type Props = {
	salesTerm: StandardRoomCategoriesAndManagerStore["salesTerm"];
};

export const QuestionRoomSalesTerm = ({ salesTerm }: Props) => {
	return (
		<FeatureIslandMainWithCategoryWrapper islandTitle="販売期間" categoryStore={salesTerm}>
			<QuestionRoomRequiredPrepMillisecond />
		</FeatureIslandMainWithCategoryWrapper>
	);
};

QuestionRoomSalesTerm.displayName = "QuestionRoomSalesTerm";
